import { useContext, useState } from 'react';
import LabelledInput from '../../atoms/LabelledInput/LabelledInput';
import WideButton from '../../atoms/WideButton/WideButton';
import Dialog from '../Dialog/Dialog';
import GlobalVariablesContext from '../../contexts/GlobalVariablesContext';
import Spinner from '../../atoms/Spinner/Spinner';
import ToggleSwitch from '../../atoms/ToggleSwitch/ToggleSwitch';
import WarningAlert from '../../atoms/WarningAlert/WarningAlert';
import './GiftLinkDialog.scss';
import GiftLink from '../../atoms/GiftLink/GiftLink';

interface GiftLinkDialogProps {
    url?: string;
    title?: string;
    onSaved: (url: string, title: string) => void;
    onCancel: () => void;
}

const GiftLinkDialog = (props: GiftLinkDialogProps) => {

    const { giftsApi } = useContext(GlobalVariablesContext);

    const [linkUrl, setLinkUrl] = useState(props.url);

    const [linkTitle, setLinkTitle] = useState(props.title);

    const [removeTracking, setRemoveTracking] = useState(false);

    const [loadingTitle, setLoadingTitle] = useState(false);

    const isValidUrl = (url: string) => {
        let result = null as URL;
        try {
            result = new URL(url);
        } catch (_) {
            return false;
        }
        return result.protocol === "http:" || result.protocol === "https:";
    }

    const removeQueryParams = (url: string) => {
        try {
            const urlObj = new URL(url);
            return `${urlObj.protocol}//${urlObj.host}${urlObj.pathname}`;
        } catch (_) {
            return url;
        }
    }

    const handleUrlChanged = async () => {
        if (!isValidUrl(linkUrl)) {
            return;
        }
        setLoadingTitle(true);
        await giftsApi
            .scrape(linkUrl)
            .then(data => {
                setLinkTitle(data.data.pageTitle);
            })
            .finally(() => {
                setLoadingTitle(false);
            });
    }

    const handleSaveButtonClick = () => {
        const urlToSave = removeTracking ? removeQueryParams(linkUrl) : linkUrl;
        props.onSaved(urlToSave, linkTitle);
    }

    const handleCancelButtonClick = () => {
        props.onCancel();
    }

    return (
        <Dialog className="gift-link-dialog" onClose={handleCancelButtonClick}>
            <h1>Gift Link</h1>
            <LabelledInput name="linkUrl" label="Link URL" placeholder="Enter Website Address (URL)" required={true} value={linkUrl} onBlur={() => handleUrlChanged()} onChange={e => setLinkUrl(e.target.value)} />
            {loadingTitle &&
                <>
                    <p>Getting title...</p>
                    <Spinner />
                </>
            }
            {!loadingTitle &&
                <>
                    <LabelledInput name="linkTitle" label="Link Title" placeholder="Enter Link Title" required={true} value={linkTitle} onChange={e => setLinkTitle(e.target.value)} />

                    {linkUrl?.indexOf('?') !== -1 &&
                        <>
                            <ToggleSwitch label="Remove tracking information" checked={removeTracking} onChange={value => setRemoveTracking(value)} />
                            {removeTracking &&
                                <WarningAlert title="Warning" message="Removing tracking information may break some links. Check that the link still works by clicking on it below!" />
                            }
                        </>
                    }

                    {linkTitle && linkUrl &&
                        <div className="gift-link">
                            <GiftLink
                                url={removeTracking ? removeQueryParams(linkUrl) : linkUrl}
                                title={linkTitle}
                                shortenUrl={false} />
                        </div>
                    }
                </>
            }

            <WideButton enabled={!loadingTitle} label="Save" onClick={() => handleSaveButtonClick()} />
            <WideButton label="Cancel" variant="red" onClick={() => handleCancelButtonClick()} />
        </Dialog>
    );
}

export default GiftLinkDialog;